import React, { useMemo } from 'react';
import Icon from 'react-icons-kit';
import { plus } from 'react-icons-kit/ikons/plus';
import { refresh } from 'react-icons-kit/ionicons/refresh';
import { getAllPayrollItemsForTable } from '../../../requests/PayrollItemRequests';
import Modal from 'react-modal';
import MinuteTable from '../../components/MinuteTable';
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit';
import '../../../css/Timesheets.css';
import Select from '../../components/Select.js';
try {
    Modal.setAppElement('#root');
} catch {}
const PayrollItemResourcesList = ({
    title,
    onClick,
    history,
    createNewLabel,
    createNewPath,
    activatePayrollItem,
    deactivatePayrollItem,
}) => {
    const columns = useMemo(
        () => [
            {
                accessor: 'name',
                Header: 'Name',
            },
            {
                accessor: 'wage_type',
                Header: 'Wage Type',
            },
            {
                Header: 'Status',
                id: 'status',
                accessor: () => 'Status',
                Cell: tableProps => (
                    <td className="tsStatusCell">
                        {tableProps.row.original.hidden === 'No' && (
                            <span
                                className="tsStatus tsStatusApproved"
                                onClick={() => onToggleApproved(tableProps.row.original)}
                            >
                                {isUpdatingStatus ? 'Updating...' : 'Active'}
                            </span>
                        )}
                        {tableProps.row.original.hidden === 'Yes' && (
                            <span
                                className="tsStatus tsStatusPending"
                                onClick={() => onToggleApproved(tableProps.row.original)}
                            >
                                {isUpdatingStatus ? 'Updating...' : 'Inactive'}
                            </span>
                        )}
                    </td>
                ),
            },
            {
                Header: 'Actions',
                id: 'actions',
                accessor: () => 'Actions',

                Cell: tableProps => (
                    <Icon
                        onClick={() => onClick(tableProps.row.original)}
                        icon={ic_mode_edit}
                        className="tableIcon asAccountUserIcon"
                        size={22}
                        data-tip="Edit Payroll Item"
                    />
                ),
            },
        ],
        []
    );

    const statusFilters = [
        { name: 'All Payroll Items', id: 'all' },
        { name: 'ACTIVE', id: 'active' },
        { name: 'INACTIVE', id: 'inactive' },
    ];
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [refreshTable, setRefreshTable] = React.useState(false);
    const [filter, setFilter] = React.useState('active');
    const [resetTable, setResetTable] = React.useState(false);
    const [isUpdatingStatus, setIsUpdatingStatus] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const fetchIdRef = React.useRef(0);
    const sortIdRef = React.useRef(0);

    const fetchData = React.useCallback(({ sortBy, pageSize, pageIndex, filter }) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        setRefreshTable(false);
        setResetTable(false);
        setTimeout(() => {
            if (fetchId === fetchIdRef.current) {
                let paramsObject = {
                    current_page: pageIndex + 1,
                    per_page: pageSize,
                    filter: filter,
                };
                Promise.all([getAllPayrollItemsForTable(paramsObject)]).then(response => {
                    let json = response[0];
                    let payrollItemsList = json.payrollItemList;
                    if (sortBy.length > 0) {
                        const sortId = ++sortIdRef.current;
                        if (sortId === sortIdRef.current) {
                            let sorted = payrollItemsList;
                            sorted.sort((a, b) => {
                                for (let i = 0; i < sortBy.length; ++i) {
                                    if (a[sortBy[i].id] > b[sortBy[i].id])
                                        return sortBy[i].desc ? -1 : 1;
                                    if (a[sortBy[i].id] < b[sortBy[i].id])
                                        return sortBy[i].desc ? 1 : -1;
                                }
                                return 0;
                            });
                            setData(payrollItemsList);
                            setPageCount(Math.ceil(json.meta.total / pageSize));
                            setLoading(false);
                        }
                    } else {
                        setData(payrollItemsList);
                        setPageCount(Math.ceil(json.meta.total / pageSize));
                        setLoading(false);
                    }
                });
            }
        }, 1000);
    }, []);

    function handleFilterChanged(value) {
        setFilter(value);
        setResetTable(true);
    }

    function onToggleApproved(payrollItem) {
        if (payrollItem.hidden === 'No') {
            setIsUpdatingStatus(true);
            deactivatePayrollItem(payrollItem.id);
            setIsUpdatingStatus(false);
            setRefreshTable(true);
        } else {
            setIsUpdatingStatus(true);
            activatePayrollItem(payrollItem.id);
            setIsUpdatingStatus(false);
            setRefreshTable(true);
        }
    }

    return (
        <div>
            <h3 className="cardHeading">
                {title}
                <div className="bodyHeader filters">
                    <div className="" style={{ fontWeight: 'lighter' }}>
                        <Select
                            toggleStyle="button"
                            className="multiselectFilter"
                            options={statusFilters}
                            value={filter}
                            defaultValue="active"
                            onChange={handleFilterChanged}
                        />
                    </div>

                    <div className="">
                        <button
                            className="secondaryButton"
                            style={{ height: '35px' }}
                            onClick={() => history.push(createNewPath)}
                        >
                            <Icon className="icon" icon={plus} size={20} />
                            {createNewLabel}
                        </button>
                    </div>
                    <div className="headerActions">
                        <button
                            className="secondaryButton"
                            style={{ height: '35px' }}
                            onClick={() => setRefreshTable(true)}
                        >
                            <Icon className="icon" icon={refresh} size={20} />
                        </button>
                    </div>
                </div>
            </h3>
            <div className="cardContainer asSection">
                <MinuteTable
                    columns={columns}
                    data={data}
                    fetchData={fetchData}
                    loading={loading}
                    pageCount={pageCount}
                    filter={filter}
                    refresh={refreshTable}
                    resetTable={resetTable}
                />
            </div>
        </div>
    );
};

export default PayrollItemResourcesList;
